import React from "react";
import { StepCard } from "./StepCard";
import { FaCreditCard, FaSearch } from "react-icons/fa";
import { FaTicket } from "react-icons/fa6";

const steps = [
  {
    step: 1,
    icon: <FaSearch />,
    title: "Escolha a Campanha",
    description:
      "Navegue pelas campanhas ativas, filtre por categoria e encontre o prêmio que você quer concorrer. Cada campanha tem detalhes completos do sorteio.",
    color: "var(--gold)",
  },
  {
    step: 2,
    icon: <FaTicket />,
    title: "Selecione os Tickets",
    description:
      "Escolha quantos tickets quer comprar. Quanto mais tickets, maiores as suas chances de ganhar. Escolha os números da sorte ou deixe sortear.",
    color: "#6C63FF",
  },
  {
    step: 3,
    icon: <FaCreditCard />,
    title: "Pague para Concorrer",
    description:
      "Pague com Pix, cartão de crédito ou débito de forma 100% segura. Após a confirmação, seus tickets são reservados e você já está concorrendo!",
    color: "var(--teal)",
  },
];

const HowItWorks: React.FC = () => {
  return (
    <section className="bg-white py-5 px-3">
      {/* CONTAINER COM RESPIRO REAL */}
      <div
        className="container px-3 px-md-4 px-lg-0"
        style={{ maxWidth: 1240 }}
      >
        {/* HEADER */}
        <div className="text-center mb-4 mb-md-5">
          <span className="text-warning fw-bold fs-3 d-block mb-2">
            Como funciona?
          </span>

          <h2
            className="fw-bold mb-2"
            style={{
              fontSize: "clamp(1.5rem, 4vw, 2.2rem)",
            }}
          >
            Participe em 3 passos simples
          </h2>

          <p
            className="text-muted mx-auto"
            style={{
              maxWidth: 520,
              fontSize: "clamp(0.9rem, 3.5vw, 1rem)",
              lineHeight: 1.6,
            }}
          >
            Em poucos minutos você já está concorrendo ao prêmio. Processo
            rápido, seguro e transparente.
          </p>
        </div>

        {/* STEPS */}
        <div className="row g-3 g-md-4">
          {steps.map((s) => (
            <div key={s.step} className="col-12 col-md-4">
              <StepCard {...s} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
